<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('ReceivingPoints')"
          :description="$t('from Here You Can Control Your Receipt Points')"
          :explanationPath="path + '/explaination'"
        />
        <indexTable
          :searchText="$t('SearchForAReceivingPoint')"
          :emptyTableText="$t('ThereAreNoReceivingPoints')"
          :buttonRole="$checkRole('pickupLocations_add')"
          :localData="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :cloumns="[
            {
              column: 'name',
              title: $t('the Name Of The Pickup Locations'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'mobile',
              title: $t('mobile'),
              type: 'text',
              sort: true
            },
            {
              column: 'city',
              title: $t('City'),
              type: 'text',
              sort: true
            },
            {
              column: 'country',
              title: $t('Country'),
              type: 'text',
              sort: true
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('pickupLocations_edit')
                },
                {
                  name: 'link',
                  role: $checkRole('pickupLocations_transfers_add'),
                  title: $t('MoveFromTheStore'),
                  icon: 'suitcase',
                  link: '/pickupLocationsTransfers/create/'
                },
                {
                  name: 'link',
                  role: $checkRole('pickupLocations_deposits_add'),
                  title: $t('DepositToTheStore'),
                  icon: 'donate',
                  link: '/pickupLocationsDeposits/create/'
                },
                {
                  name: 'link',
                  role: $checkRole('pickupLocations_withdrawals_add'),
                  title: $t('EnglishPullOutOfTheStore'),
                  icon: 'money-bill-alt',
                  link: '/pickupLocationsWithdrawals/create/'
                },
                {
                  name: 'delete',
                  role: $checkRole('pickupLocations_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/pickupLocations'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
